import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Candidature} from './candidature.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class CandidatureService {

    private resourceUrl = 'api/candidatures';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(candidature: Candidature): Observable<Candidature> {
        let copy: Candidature = Object.assign({}, candidature);
        if (candidature.dateNaissance != null && candidature.dateNaissance.getDate()) {
            copy.dateNaissance = new Date(Date.UTC(candidature.dateNaissance.getFullYear(),
                candidature.dateNaissance.getMonth(), candidature.dateNaissance.getDate()));
        }
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.dateNaissance = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    }

    update(candidature: Candidature): Observable<Candidature> {
        let copy: Candidature = Object.assign({}, candidature);
        if (candidature.dateNaissance != null && candidature.dateNaissance.getDate()) {
            copy.dateNaissance = new Date(Date.UTC(candidature.dateNaissance.getFullYear(),
                candidature.dateNaissance.getMonth(), candidature.dateNaissance.getDate()));
        }
        if (CandidatureService.empty(copy.paysNationalite)) copy.paysNationalite = null;
        if (CandidatureService.empty(copy.paysNaissance)) copy.paysNaissance = null;
        if (CandidatureService.empty(copy.deptNaissance)) copy.deptNaissance = null;
        if (CandidatureService.empty(copy.bacPays)) copy.bacPays = null;
        if (CandidatureService.empty(copy.bacDept)) copy.bacDept = null;
        if (CandidatureService.empty(copy.bacVille)) copy.bacVille = null;

        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.dateNaissance = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    }

    private static empty(stringValue: String) {
        return typeof stringValue == 'undefined' || !stringValue || stringValue.length == 0;
    }

    find(id: number): Observable<Candidature> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.dateNaissance = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateNaissance);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map((res: any) => this.convertResponse(res));
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    static copyCandidature(candidature: Candidature, toCopy: Candidature): Candidature {
        candidature.bac = toCopy.bac;
        candidature.bacAnnee = toCopy.bacAnnee;
        candidature.bacDept = toCopy.bacDept;
        candidature.bacEtab = toCopy.bacEtab;
        candidature.bacEtablissementAutre = toCopy.bacEtablissementAutre;
        candidature.bacMention = toCopy.bacMention;
        candidature.bacPays = toCopy.bacPays;
        candidature.bacVille = toCopy.bacVille;
        candidature.bacTypeEtablissement = toCopy.bacTypeEtablissement;
        candidature.telephoneFixe = toCopy.telephoneFixe;
        candidature.telephonePortable = toCopy.telephonePortable;
        candidature.paysNaissance = toCopy.paysNaissance;
        candidature.paysNationalite = toCopy.paysNationalite;
        candidature.paysNationalite2 = toCopy.paysNationalite2;
        candidature.deptNaissance = toCopy.deptNaissance;
        candidature.villeNaissance = toCopy.villeNaissance;
        candidature.ines = toCopy.ines;
        candidature.bourse = toCopy.bourse;
        candidature.bacSpec1LibelleCourt = toCopy.bacSpec1LibelleCourt;
        candidature.bacSpec2LibelleCourt = toCopy.bacSpec2LibelleCourt;
        return candidature;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateNaissance = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].dateNaissance);
        }
        res._body = jsonResponse;
        return res;
    }

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature.service.ts